import { get } from 'lodash';
import { reject } from 'redux-optimist-promise';
import { FETCH_ADDITIONAL_TRANSPORTS } from 'Store/booking/additional-transports/additionalTransports.action';
import { FETCH_PROPOSALS_BY_ID } from 'Store/booking/proposals/constants';
type State = HTTPError | null | undefined;
const initialState: State = null;

function additionalTransportsErrorReducer(
  state: State = initialState,
  action: Action<any> | null | undefined,
): State {
  switch (get(action, 'type')) {
    case FETCH_ADDITIONAL_TRANSPORTS:
      return initialState;

    case reject(FETCH_ADDITIONAL_TRANSPORTS):
    case reject(FETCH_PROPOSALS_BY_ID):
      const error = get(action, 'payload.errors[0]', {});
      return {
        statusCode: error.statusCode || 500,
        message: error.message || 'UNKNOWN ERROR',
      };

    default:
      return state;
  }
}

export default additionalTransportsErrorReducer;
